import { myPalette } from '~/shared/ui/theme'

type EmptyListProps = {
  title?: string
  description?: string
}

export function EmptyList({ title, description }: EmptyListProps) {
  return (
    <div
      style={{
        textAlign: 'center',
        margin: '60px 0',
      }}
    >
      <div
        style={{
          fontSize: '18px',
          fontWeight: 700,
          color: myPalette.midnightBlue.main,
          marginBottom: '16px',
        }}
      >
        {title || 'У вас нет штрафов'}
      </div>
      <div style={{ fontSize: '14px', color: myPalette.midnightBlue.main }}>
        {description || 'Здесь будет отображаться список штрафов'}
      </div>
    </div>
  )
}
